import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const NotificationItem = ({ notification, onToggleRead }) => {
    return (
        <div className="border-b">
            <div
                className={`flex items-center justify-between p-3 mt-2 mb-2 ${notification.read ? "border-l-blue-500 border-l-4" : "border-l-0"
                    }`}
            >
                <div className="flex items-start">
                    <input
                        type="checkbox"
                        checked={notification.read}
                        onChange={() => onToggleRead(notification.id)}
                        className="w-5 h-5 mr-3 text-blue-500 border-gray-300 rounded focus:ring focus:ring-blue-200"
                    />
                    <Link to={`${notification.id}`}>
                        <p className={`${notification.read && "font-bold"} text-base`}>{notification.text}</p>
                        <p className="text-sm text-gray-400">
                            {notification.date} • {notification.time}
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    );
};

// **PropTypes Validation**
NotificationItem.propTypes = {
    notification: PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
        time: PropTypes.string,
        date: PropTypes.string,
        read: PropTypes.bool,
    }),
    onToggleRead: PropTypes.func,
};

export default NotificationItem;
